import { createContext, useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';

const HistoryContext = createContext();

const HistoryProvider = ({ children }) => {
	const [refreshTrigger, setRefreshTrigger] = useState(0);
	const [historyMeta, setHistoryMeta] = useState([]);
	const hasInitialFetch = useRef(false);
	const previousRefreshTrigger = useRef(0);

	const refreshHistory = useCallback(() => {
		hasInitialFetch.current = true;
		setRefreshTrigger((prev) => prev + 1);
	}, []);

	const markInitialFetch = useCallback(() => {
		hasInitialFetch.current = true;
	}, []);

	const getShouldFetch = useCallback(() => {
		const shouldFetch = !hasInitialFetch.current || refreshTrigger !== previousRefreshTrigger.current;
		previousRefreshTrigger.current = refreshTrigger;
		return shouldFetch;
	}, [refreshTrigger]);

	return (
		<HistoryContext.Provider
			value={{
				refreshHistory,
				refreshTrigger,
				hasInitialFetch: hasInitialFetch.current,
				markInitialFetch,
				getShouldFetch,
				historyMeta,
				setHistoryMeta,
			}}
		>
			{children}
		</HistoryContext.Provider>
	);
};

HistoryProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export { HistoryProvider, HistoryContext };
